/**
 * Lightweight app-wide bus for notification read-state changes.
 * Lets the Notifications page instantly sync every badge
 * (header bell, bottom-nav Messages, native app icon) without
 * waiting on realtime delivery.
 */

const EVENT = 'vent:notifications-read';

export interface NotificationsReadDetail {
  /** true when every notification was marked read (badge should zero) */
  all: boolean;
}

export const emitNotificationsRead = (all: boolean) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<NotificationsReadDetail>(EVENT, { detail: { all } })
  );
};

export const onNotificationsRead = (
  cb: (detail: NotificationsReadDetail) => void
): (() => void) => {
  const handler = (e: Event) =>
    cb((e as CustomEvent<NotificationsReadDetail>).detail);
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
};
